import { isChatExcludedPath } from "./exclusions";

export const isChatVisible = ({ pathname, suppressions, excludedPaths }) =>
  !isChatExcludedPath(excludedPaths)(pathname) && suppressions.size === 0;

const VIEW_BY_STATUS = Object.freeze({
  idle: "button",
  failed: "button",
  loading: "busy",
  ready: "hidden",
});

export const launcherView = ({ status, visible }) =>
  visible ? VIEW_BY_STATUS[status] : "hidden";
